import { createNavBlocker } from './../..';
import { createBrowserHistory, createMemoryHistory } from 'history';
export var createHistory = function (type, navBlocker, basename) {
    var unblock = function () { return null; }; // default value to begin with
    var createFn = type === 'memory' ? createMemoryHistory : createBrowserHistory;
    var history = createFn({
        getUserConfirmation: function (_, callback) {
            navBlocker.setBlockReleaser(callback);
            navBlocker.reportBlocked();
        },
        basename: basename
    });
    navBlocker.addListener(function (isBlocked) {
        if (isBlocked) {
            var dummyMsg = 'needed so get user confirmation gets called';
            unblock = history.block(dummyMsg);
        }
        else {
            unblock();
        }
    });
    return history;
};
export var createTestHistory = function () {
    return createHistory('memory', createNavBlocker(), '');
};
//# sourceMappingURL=index.js.map